import { clsx } from 'clsx';
import {
  type ComponentPropsWithRef,
  type ReactNode,
  useId,
  useRef,
} from 'react';
import { useComposedRefs } from '../utils/use-composed-refs.ts';
import {
  inputV2,
  inputV2Container,
  inputV2Sizes,
  type InputV2Size,
} from './input-v2.css.ts';

export type { InputV2Size };

export type InputV2Props = Omit<ComponentPropsWithRef<'input'>, 'size'> & {
  before?: ReactNode;
  after?: ReactNode;
  inputClassName?: string;
  size?: InputV2Size;
};

export const InputV2 = ({
  className,
  inputClassName,
  before,
  after,
  id,
  ref,
  autoComplete = 'off',
  disabled,
  size = 'default',
  ...rest
}: InputV2Props) => {
  const reactId = useId();
  const inputId = id || reactId;
  const inputRef = useRef<HTMLInputElement>(null);
  const setInputRef = useComposedRefs(ref, inputRef);

  return (
    <div
      className={clsx(inputV2Container, inputV2Sizes[size], className)}
      data-disabled={disabled ? '' : undefined}
    >
      {before}
      <input
        type="text"
        ref={setInputRef}
        id={inputId}
        autoComplete={autoComplete}
        disabled={disabled}
        className={clsx(inputV2, inputClassName)}
        {...rest}
      />
      {after}
    </div>
  );
};
